import { DISPLAY_TYPES, STATUS_TYPES } from "../constants";

/* ============================================================
   📌 MOCK (para testes e sidebar)
   ============================================================ */
import image4 from "../assets/images/small/img-4.jpg";
import avatar1 from "../assets/images/users/avatar-1.jpg";
import img1 from "../assets/images/small/img-1.jpg";
import img2 from "../assets/images/small/img-2.jpg";
import img4 from "../assets/images/small/img-4.jpg";

/* ============================================================
   📌 Basic Details (padrão Themesbrand)
   ============================================================ */

export interface BasicDetailsTypes {
  id: number;
  idEnterprise: number;
  idCliente: number;

  firstName: string;
  lastName: string;

  title?: string;
  description?: string;

  fullName: string;
  email?: string;
  location?: string;

  avatar: string;
  cover: string;

  blockedMessage?: string;
  lastMessage?: string;
  unreadCount: number;
  lastMessageTime?: string;

  cpfCnpj?: string;
  name?: string;
  address?: string;
  situacao?: string;

  obs?: string;
  obsAtendimento?: string;

  foto1?: string;
  foto2?: string;
  foto3?: string;

  arquivo1?: string;
  arquivo2?: string;

  ativo?: number;
  marked?: number;
  idRegiao?: number;
  regiao?: string;
  phoneNumber?: string;
  dataVisita?: string;
  obsVisita?: string;

  Blocked: boolean;
  in24hWindow: boolean;
}

export interface BasicDetailsTypesProfile {
  id: number;
  firstName: string;
  lastName: string;

  title?: string;
  description?: string;

  fullName: string;
  email?: string;
  location?: string;

  avatar: string;
  cover: string;

  enterprise: string;
  role: string;
}

/* ============================================================
   📎 Mídia
   ============================================================ */

export interface MediaListItemTypes {
  id: number;
  url: string;
}

export interface MediaTypes {
  total: number;
  list: MediaListItemTypes[];
}

/* ============================================================
   📎 Arquivos
   ============================================================ */

export interface AttachedfileItemTypes {
  id: number;
  fileName: string;
  size: string;
  downloadUrl: string;
  icon: string;
}

export interface AttachedfileTypes {
  total: number;
  list: AttachedfileItemTypes[];
}

/* ============================================================
   📌 Perfil completo Themesbrand (UI principal usa este)
   ============================================================ */

export interface IContactDetailsTypes {
  basicDetails: BasicDetailsTypes;
  media: MediaTypes;
  attachedFiles: AttachedfileTypes;
}

export interface IProfileDetailsTypes {
  basicDetails: BasicDetailsTypesProfile;
  media: MediaTypes;
  attachedFiles: AttachedfileTypes;
}

/* ============================================================
   📌 Detalhes do Usuário no Chat (USAR ESTE!)
   — compatível com toda UI Themesbrand
   ============================================================ */

export interface IChatUserDetails {
  basicDetails: BasicDetailsTypes;
  media: MediaTypes;
  attachedFiles: AttachedfileTypes;
}

export const profileDetails: IProfileDetailsTypes = {
  basicDetails: {
    id: 1,
    firstName: "Adam",
    lastName: "Zampa",
    title: "Front end Developer",
    description:
      "If several languages coalesce, the grammar of the resulting language is more simple.",
    fullName: "Adam Zampa",
    email: "admin@themesbrand.com",
    location: "California, USA",
    enterprise: "RW Consultoria",
    role: "Administrador",
    avatar: avatar1,
    cover: image4,
  },

  media: {
    total: 5,
    list: [
      { id: 1, url: img1 },
      { id: 2, url: img2 },
      { id: 3, url: img4 },
      { id: 4, url: img1 },
      { id: 5, url: img1 },
    ],
  },

  attachedFiles: {
    total: 3,
    list: [
      {
        id: 1,
        fileName: "contract.pdf",
        size: "2.3 MB",
        downloadUrl: "#",
        icon: "bx bx-file",
      },
      {
        id: 2,
        fileName: "design.png",
        size: "1.1 MB",
        downloadUrl: "#",
        icon: "bx bx-image",
      },
      {
        id: 3,
        fileName: "notes.txt",
        size: "18 KB",
        downloadUrl: "#",
        icon: "bx bx-file",
      },
    ],
  },
};

export const contactDetails: IContactDetailsTypes = {
  basicDetails: {
    id: 1,
    idCliente: 0,
    idEnterprise: 0,
    firstName: "Adam",
    lastName: "Zampa",
    title: "Front end Developer",
    description:
      "If several languages coalesce, the grammar of the resulting language is more simple.",
    fullName: "Adam Zampa",
    email: "admin@themesbrand.com",
    location: "California, USA",
    avatar: avatar1,
    cover: image4,

    lastMessage: "",
    lastMessageTime: "",
    blockedMessage: "",
    unreadCount: 0,

    ativo: -2,
    marked: 0,
    idRegiao: 0,
    regiao: "Indefinido",

    phoneNumber: "Indefinido",
    dataVisita: "",
    obsVisita: "",
    Blocked: false,
    in24hWindow: false,
  },

  media: {
    total: 5,
    list: [
      { id: 1, url: img1 },
      { id: 2, url: img2 },
      { id: 3, url: img4 },
      { id: 4, url: img1 },
      { id: 5, url: img1 },
    ],
  },

  attachedFiles: {
    total: 3,
    list: [
      {
        id: 1,
        fileName: "contract.pdf",
        size: "2.3 MB",
        downloadUrl: "#",
        icon: "bx bx-file",
      },
      {
        id: 2,
        fileName: "design.png",
        size: "1.1 MB",
        downloadUrl: "#",
        icon: "bx bx-image",
      },
      {
        id: 3,
        fileName: "notes.txt",
        size: "18 KB",
        downloadUrl: "#",
        icon: "bx bx-file",
      },
    ],
  },
};

export interface ThemeTypes {
  color?: string;
  image: string;
}

export interface PrivacyTypes {
  displayprofilePhoto: string;
  displayLastSeen: boolean;
  displayStatus:
    | DISPLAY_TYPES.EVERYONE
    | DISPLAY_TYPES.SELECTED
    | DISPLAY_TYPES.EVERYONE;
  readReceipts: boolean;
  displayGroups:
    | DISPLAY_TYPES.EVERYONE
    | DISPLAY_TYPES.SELECTED
    | DISPLAY_TYPES.EVERYONE;
}

export interface SecurityTypes {
  securityNotification: boolean;
}

export interface SettingsTypes {
  basicDetails: BasicDetailsTypesProfile;
  theme: ThemeTypes;
  privacy: PrivacyTypes;
  security: SecurityTypes;
  status: STATUS_TYPES.ACTIVE | STATUS_TYPES.AWAY | STATUS_TYPES.DO_NOT_DISTURB;
}

// ✅ estado inicial
export const defaultSettings: SettingsTypes = {
  basicDetails: profileDetails.basicDetails,
  theme: {
    image: "bgimg-radio5",
  },
  privacy: {
    displayprofilePhoto: "selected",
    displayLastSeen: true,
    displayStatus: DISPLAY_TYPES.EVERYONE,
    readReceipts: true,
    displayGroups: DISPLAY_TYPES.EVERYONE,
  },
  security: {
    securityNotification: false,
  },
  status: STATUS_TYPES.ACTIVE,
};
